// src/components/P2P.js
import React, { useEffect, useState, useRef, useCallback } from "react";
import { toastSuccess, toastError, toastInfo } from "../utils/toast";
import BuyOrder     from "./BuyOrder";
import {
  sendSystemMessage
} from "../utils/sendSystemMessage";
import OrderPayment from "./OrderPayment";
import Orders       from "./Orders";
import { CURRENCIES } from "../constants/currency";

export default function P2P({
  socket,
  myChatId,
  users = [],
  offers,
  setOffers,
  setMyAds,
  myUsdtAd,
setMyUsdtAd,
  setP2pOffers,
  p2pOrders,
  p2pEvent,
  clearP2pEvent,
  orderTimers,
  wallet,
  activeP2POrder,
  setActiveP2POrder,
  activeP2PPage,
  setActiveP2PPage,
   sendMessage, 
  setMessages,
   onConfirmPayment,
    setUsers,
  setPendingMedia,
  getUserKey,
    showToast,
  uuid,
  onRefreshOffers,
  sellerPaymentDetails,
  sellerCurrency,
  loadSellerPaymentDetails,
  onGetMyUsdtAd,
  myAds = [],
   onUpdateAd,   
onUpdateUsdtAd,
onCancelUsdtAd,
  onCreateAd,
  onCreateOrder,
  onOpenDm,   // (sellerChatId, sellerUsername) → parent opens DM + switches tab
  onBack,
  mobileView,
}) {

  /* -----------------------------------
     STATIC DATA
  ----------------------------------- */
  const ASSETS = ["USWD", "USDT"];

  const PAYMENT_TYPES = [
    "MTN Mobile Money",
    "Vodafone Cash",
    "AirtelTigo Money",
    "Bank Transfer",
    "WorldRemit",
    "Western Union",
    "Remitly",
  ];

  /* -----------------------------------
     UI STATE
  ----------------------------------- */
  const [mode,          setMode]          = useState("buy");
  const [selectedAsset, setSelectedAsset] = useState(() => {
    try {
      return sessionStorage.getItem("p2p:selectedAsset") || "USDT";
    } catch {
      return "USDT";
    }
  });
  const [searchQuery,   setSearchQuery]   = useState("");
const [creatingAd, setCreatingAd] = useState(false);
const [updatingAd, setUpdatingAd] = useState(false);
const editingUsdtAd = myUsdtAd;

// USWD ad currently being edited — sourced from myAds, the same
// parent-synced cache useP2PSocket keeps live via p2p:ad-created,
// p2p:ad-updated, p2p:ad-deleted and uswd:get-my-ad. Mirrors how
// editingUsdtAd derives from myUsdtAd.
const editingUswdAd = myAds?.[0] ?? null;

const [deletingAdId, setDeletingAdId] = useState(null);
const [creatingOrder, setCreatingOrder] = useState(false);

  const [rate,            setRate]            = useState("");
  const [minLimit,        setMinLimit]        = useState("");
  const [maxLimit,        setMaxLimit]        = useState("");
  const [availableAmount, setAvailableAmount] = useState("");

  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showCurrencyPicker, setShowCurrencyPicker] = useState(false);
  const [selectedCurrency,   setSelectedCurrency]   = useState("GHS");
  const [paymentDetails,     setPaymentDetails]     = useState({});
  const [paymentInstruction, setPaymentInstruction] = useState("");
  const [pendingAdPayload,   setPendingAdPayload]   = useState(null);

  const [marketCurrency, setMarketCurrency] = useState(sellerCurrency || "GHS");
const [page,        setPage]        = useState(1);
const [hasMore,     setHasMore]     = useState(true);
const [loadingMore, setLoadingMore] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
 const [activeOrder,   setActiveOrder]   = useState(() => activeP2POrder || null);

  const [showBuyModal,  setShowBuyModal]  = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [buyAmount,     setBuyAmount]     = useState("");
const [savingCurrency, setSavingCurrency] = useState(false);
const [confirmDeleteAdId, setConfirmDeleteAdId] = useState(null);
const [cancelTargetAsset, setCancelTargetAsset] = useState(null); // "USWD" | "USDT" — which flow to run on confirm
  const [showAdDone, setShowAdDone] = useState(false);
const [adDoneInfo, setAdDoneInfo] = useState(null); // { action: "created" | "updated", asset }

 /* -----------------------------------
     CURRENCY HELPERS
  ----------------------------------- */
  const getCurrencySymbol = (code) => {
    if (!code) return "";
    return CURRENCIES.find((c) => c.code === code)?.symbol || code;
  };

  /* -----------------------------------
     NUMERIC INPUT HELPER (max 2 decimal places)
  ----------------------------------- */
  const sanitizeDecimal2 = (raw) => {
    if (raw === "") return "";

    // strip anything that isn't a digit or a dot
    let v = raw.replace(/[^0-9.]/g, "");

    // collapse multiple dots down to the first one
    const firstDot = v.indexOf(".");
    if (firstDot !== -1) {
      v =
        v.slice(0, firstDot + 1) +
        v.slice(firstDot + 1).replace(/\./g, "");
    }

    // cap to 2 digits after the decimal point
    const [intPart, decPart] = v.split(".");
    if (decPart !== undefined) {
      v = `${intPart}.${decPart.slice(0, 2)}`;
    }

    return v;
  };

  /* -----------------------------------
     P2P EVENT BUS
  ----------------------------------- */
  useEffect(() => {
    if (!p2pEvent) return;

    switch (p2pEvent.type) {

    case "AD_CREATED": {

  const event = p2pEvent.payload;

  setCreatingAd(false);

  if (event?.error) {
    toastError(event.error);
    clearP2pEvent?.();
    return;
  }

  if (event?.requirePaymentDetails) {
    setShowPaymentDetails(true);
    clearP2pEvent?.();
    return;
  }

 setAdDoneInfo({ action: "created", asset: "USWD" });
  setShowAdDone(true);

  clearP2pEvent?.();
  break;
}

case "AD_UPDATED": {
  const event = p2pEvent.payload;

  setUpdatingAd(false);

  if (event?.error) {
    toastError(event.error);
    clearP2pEvent?.();
    break;
  }

  if (event?.ad) {
    setOffers?.((prev = []) =>
      prev.map((a) =>
        String(a.adId) === String(event.ad.adId) ? event.ad : a
      )
    );

    // editingUswdAd derives from myAds[0], so just keeping myAds in
    // sync here is enough — no separate local state to update.
    setMyAds?.([event.ad]);
  }

  setAdDoneInfo({ action: "updated", asset: "USWD" });
  setShowAdDone(true);

  clearP2pEvent?.();
  break;
}

      case "AD_DELETED": {
        setDeletingAdId(null);
        toastSuccess("Advertisement deleted");
        clearP2pEvent?.();
        break;
      }

      case "DELETE_AD_ERROR": {
        setDeletingAdId(null);
        toastError(
          p2pEvent.payload?.error ||
          "Failed to delete advertisement"
        );
        clearP2pEvent?.();
        break;
      }

      case "PAYMENT_DETAILS_SAVED": {
        setShowPaymentDetails(false);
        if (pendingAdPayload) {
          const payload = pendingAdPayload;
          setPendingAdPayload(null);
          setCreatingAd(true);
          onCreateAd(payload);
        }
        clearP2pEvent?.();
        break;
      }

      case "UPDATE_CURRENCY_SUCCESS": {
        setSavingCurrency(false);
        setShowCurrencyPicker(false);
        toastSuccess("Currency saved");
        clearP2pEvent?.();
        break;
      }

      case "UPDATE_CURRENCY_ERROR": {
        setSavingCurrency(false);
        toastError(p2pEvent.payload?.error || "Failed to save currency");
        clearP2pEvent?.();
        break;
      }

   case "USDT_AD_CREATED": {
  const event = p2pEvent.payload;
  setCreatingAd(false);

  if (event?.error) {
    toastError(event.error);
    clearP2pEvent?.();
    return;
  }
if (event?.ad) {
    if (!event.fromBroadcast) {
        setMyAds?.((prev) => [...prev, event.ad]);
        setMyUsdtAd?.(event.ad);
    }

    setP2pOffers?.((prev = []) => {
        const list = Array.isArray(prev) ? prev : [];

        const exists = list.some(
            (a) => String(a.adId) === String(event.ad.adId)
        );

        if (exists) return list;

        return [event.ad, ...list];
    });
}

 if (!event.fromBroadcast) {
    setAdDoneInfo({ action: "created", asset: "USDT" });
    setShowAdDone(true);
  }

  clearP2pEvent?.();
  break;
}
case "USDT_MY_AD_FETCHED": {
  const ad = p2pEvent.payload?.ad ?? null;

  setCreatingAd(false);
  setUpdatingAd(false);

  if (ad) {
    setMyUsdtAd?.(ad);

    setRate(String(ad.rate ?? ""));
    setMinLimit(String(ad.minLimit ?? ""));
    setMaxLimit(String(ad.maxLimit ?? ""));
    setAvailableAmount(String(ad.availableAmount ?? ""));
  } else {
    setMyUsdtAd?.(null);

    setRate("");
    setMinLimit("");
    setMaxLimit("");
    setAvailableAmount("");
  }

  clearP2pEvent?.();
  break;
}

case "USDT_AD_UPDATED": {
  const event = p2pEvent.payload;

  // Always clear the loading state, regardless of which of the two
  // server events (direct ack vs. broadcast) happens to still be in
  // the p2pEvent slot when this effect runs — otherwise the button
  // can get stuck on "Updating..." if the broadcast overwrites the
  // success event before React processes it.
  setUpdatingAd(false);

  if (event?.error) {
    toastError(event.error);
    clearP2pEvent?.();
    break;
  }

  if (event?.ad) {
    // Update the marketplace list for everyone.
    setP2pOffers?.((prev = []) =>
      prev.map((a) =>
        String(a.adId) === String(event.ad.adId)
          ? event.ad
          : a
      )
    );

    // Only the seller updates their cached ad and "My Ads".
    if (!event.fromBroadcast) {
      setMyUsdtAd?.(event.ad);

      setMyAds?.((prev = []) =>
        prev.map((a) =>
          String(a.adId) === String(event.ad.adId)
            ? event.ad
            : a
        )
      );
    }
  }

 if (!event?.fromBroadcast) {
    setAdDoneInfo({ action: "updated", asset: "USDT" });
    setShowAdDone(true);
  }

  clearP2pEvent?.();
  break;
}
case "USDT_AD_UPDATE_ERROR": {
  setUpdatingAd(false);

  toastError(
    p2pEvent.payload?.error ||
      "Failed to update advertisement"
  );

  clearP2pEvent?.();
  break;
}

case "USDT_AD_CANCELLED": {
  const event = p2pEvent.payload;

  if (event?.error) {
    toastError(event.error);
    clearP2pEvent?.();
    break;
  }

  const cancelledAdId = event?.ad?.adId;

  // Ad is no longer live (cancelled by the seller, or fully sold —
  // useUsdtSocket routes both through this same case) — drop it from
  // the marketplace list immediately instead of waiting for a refresh.
  if (cancelledAdId != null) {
    setP2pOffers?.((prev = []) =>
      prev.filter((a) => String(a.adId) !== String(cancelledAdId))
    );
  }

  // Only the seller's own cached ad / "My Ads" / form need resetting.
  // Note: we can't gate this on `fromBroadcast` — when someone else's
  // purchase exhausts OUR ad (status "completed"), we only ever learn
  // about it via the broadcast (there's no separate direct ack for the
  // seller in that flow), so we'd wrongly skip resetting our own form.
  // Compare against the cached ad's own id instead.
  const isMyAd =
    cancelledAdId != null &&
    String(myUsdtAd?.adId) === String(cancelledAdId);

  if (isMyAd || !event?.fromBroadcast) {
    // Cancelled ad is closed — clear the cached ad so the form
    // resets to "Create Advertisement" instead of "Update".
    setMyUsdtAd?.(null);
    setMyAds?.((prev = []) =>
      prev.filter(
        (a) => String(a.adId) !== String(cancelledAdId)
      )
    );

    setRate("");
    setMinLimit("");
    setMaxLimit("");
    setAvailableAmount("");

    toastSuccess(
      event?.ad?.status === "completed"
        ? "Advertisement sold out"
        : "Advertisement cancelled — funds returned to your wallet"
    );
  }

  clearP2pEvent?.();
  break;
}

case "USDT_AD_CANCEL_ERROR": {
  toastError(
    p2pEvent.payload?.error ||
      "Failed to cancel advertisement"
  );

  clearP2pEvent?.();
  break;
}
      case "USDT_AD_ERROR": {
        setCreatingAd(false);
        toastError(p2pEvent.payload?.error || "Failed to create USDT ad");
        clearP2pEvent?.();
        break;
      }

case "ORDER_CREATED": {
  (async () => {
    const data = p2pEvent.payload;

    setCreatingOrder(false);

    if (data?.error) {
      clearP2pEvent?.();
      return;
    }

    setShowBuyModal(false);

    const selected = sellerPaymentDetails.find(
      (p) => p.type === selectedPaymentType
    );

    if (selected) {
      await sendSystemMessage({
        socket,
        myChatId,
        recipientChatId: data.sellerChatId,
        senderText: `PAYMENT DETAILS\n\n${selected.type}\n\n${selected.details}${
          selected.instruction ? `\n\nInstructions\n\n${selected.instruction}` : ""
        }`,
        recipientText: `PAYMENT DETAILS\n\n${selected.type}\n\n${selected.details}${
          selected.instruction ? `\n\nInstructions\n\n${selected.instruction}` : ""
        }`,
        system: true,
        getUserKey,
        setMessages,
        setUsers,
        showToast,
        uuid,
        file: null,
        uploadMedia: null,
        setIsUploading: null,
        setUploadProgress: null,
      });
    }

    setSelectedOffer(null);
    setBuyAmount("");

  const order = {
  orderId:        data.orderId,
  sellerChatId:   data.sellerChatId,
  sellerUsername: data.sellerUsername,
  displayName:    data.displayName || data.sellerUsername,
  buyerChatId:    data.buyerChatId,
  amount:         data.amount,
  adId:           data.adId,
  asset:          data.asset,
  rate:           data.rate,
  currency:       data.currency,
};

    setActiveOrder(order);
    setActiveP2POrder(order);
    setActiveP2PPage("payment");

    clearP2pEvent?.();
  })();
  break;
}

case "USDT_ORDER_CREATED": {
  const data = p2pEvent.payload;
  setCreatingOrder(false);
  setShowBuyModal(false);
  setSelectedOffer(null);
  setBuyAmount("");
  toastSuccess(
    `${data.usdtAmount} USDT purchased successfully`
  );
  clearP2pEvent?.();
  break;
}

      case "USDT_ORDER_ERROR": {
        setCreatingOrder(false);
        if (selectedOffer) {
          setShowBuyModal(true);
        }
        toastError(p2pEvent.payload?.error || "Failed to create order");
        clearP2pEvent?.();
        break;
      }

         case "ORDER_COMPLETED": {
        clearP2pEvent?.();
        break;
      }

      case "ORDER_EXPIRED": {
        clearP2pEvent?.();
        break;
      }

      default:
        clearP2pEvent?.();
        break;
    }
  }, [p2pEvent]);

  useEffect(() => {
  setPage(1);
  setHasMore(true);
  loadOffers(1, true);
}, [selectedAsset, marketCurrency]);

useEffect(() => {
  if (mode !== "sell" || selectedAsset !== "USDT") return;

  // Already cached in memory → prefill the form directly, no network call.
  if (editingUsdtAd) {
    setRate(String(editingUsdtAd.rate ?? ""));
    setMinLimit(String(editingUsdtAd.minLimit ?? ""));
    setMaxLimit(String(editingUsdtAd.maxLimit ?? ""));
    setAvailableAmount(String(editingUsdtAd.availableAmount ?? ""));
    return;
  }

  // Not cached → fetch from server. onGetMyUsdtAd's response flows through
  // the "USDT_MY_AD_FETCHED" p2pEvent case, which sets myUsdtAd (memory)
  // AND the same form fields once the server responds.
  onGetMyUsdtAd?.();

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [mode, selectedAsset, editingUsdtAd]);

useEffect(() => {
  if (mode !== "sell") return;
  if (selectedAsset !== "USWD") return;

  if (editingUswdAd) {
    setRate(String(editingUswdAd.rate ?? ""));
    setMinLimit(String(editingUswdAd.minLimit ?? ""));
    setMaxLimit(String(editingUswdAd.maxLimit ?? ""));
    setAvailableAmount(String(editingUswdAd.availableAmount ?? ""));
    return;
  }

  setRate("");
  setMinLimit("");
  setMaxLimit("");
  setAvailableAmount("");
}, [mode, selectedAsset, editingUswdAd]);

  /* -----------------------------------
     PERSIST SELECTED ASSET ACROSS REMOUNTS
  ----------------------------------- */
  useEffect(() => {
    try {
      sessionStorage.setItem("p2p:selectedAsset", selectedAsset);
    } catch {
      // storage unavailable (private mode, etc.) — fail silently
    }
  }, [selectedAsset]);
 
  /* -----------------------------------
     iOS SAFARI / TAB RESUME
  ----------------------------------- */
  useEffect(() => {
    if (!socket) return;
    const onVisibility = () => {
      if (document.visibilityState !== "visible") return;
      if (activeOrder?.orderId) socket.emit("p2p:join-order", { orderId: activeOrder.orderId });
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [socket, activeOrder?.orderId]);

   useEffect(() => {
    if (!activeP2POrder) return;
    setActiveOrder(activeP2POrder);
  }, [activeP2POrder]);

const loadOffers = useCallback(
  async (nextPage = 1, replace = false) => {
    try {
      setLoadingMore(true);
      const data = await onRefreshOffers?.(
        selectedAsset,
        marketCurrency,
        nextPage
      );
      const newOffers = data?.offers || [];
      if (replace) {
        setOffers(newOffers);
      } else {
        setOffers(prev => [...prev, ...newOffers]);
      }
      setHasMore(Boolean(data?.hasMore));
      setPage(data?.page ?? nextPage);
    } catch (err) {
    
    } finally {
      setLoadingMore(false);
    }
  },
  [selectedAsset, marketCurrency, onRefreshOffers, setOffers]
);

  /* -----------------------------------
     CREATE SELL AD
  ----------------------------------- */
 const handleCreateAd = async (e) => {
  e.preventDefault();

  if (creatingAd || updatingAd) return;

  if (selectedAsset === "USWD" && !sellerCurrency) {
    setShowCurrencyPicker(true);
    return;
  }

  const payload = {
    chatId: myChatId,
    asset: selectedAsset,
    rate: Number(rate),
    minLimit: Number(minLimit),
    maxLimit: Number(maxLimit),
    availableAmount: Number(availableAmount),
  };

  if (
    !payload.chatId ||
    !payload.rate ||
    !payload.minLimit ||
    !payload.maxLimit ||
    !payload.availableAmount
  ) {
    toastError("Invalid ad data. Check inputs");
    return;
  }

  if (payload.minLimit > payload.maxLimit) {
    toastError("Min cannot be greater than Max");
    return;
  }

  if (payload.maxLimit > payload.availableAmount) {
    toastError("Max cannot exceed Available amount");
    return;
  }

  /*
   * USWD
   */
if (selectedAsset === "USWD") {
    if (editingUswdAd) {
      setUpdatingAd(true);
      onUpdateAd({
        adId:     editingUswdAd.adId,
        rate:     payload.rate,
        minLimit: payload.minLimit,
        maxLimit: payload.maxLimit,
        newAmount: payload.availableAmount,
      });
      return;
    }

    setCreatingAd(true);
    setPendingAdPayload(payload);
    onCreateAd(payload);
    return;
  }

  if (!editingUsdtAd) {
  setCreatingAd(true);
  setPendingAdPayload(payload);

  // USDT is custodial now — the backend just books the available
  // amount against the seller's custodial balance in the DB, no
  // on-chain transaction. The frontend just sends the ad payload.
  //
  // NOTE: the "usdt:create-ad" socket handler reads the amount as
  // `amount`, not `availableAmount` — send both so nothing else in
  // this component (which relies on `availableAmount`) has to change.
  onCreateAd({
    ...payload,
    amount: payload.availableAmount,
  });

  return;
}

  /*
   * USDT UPDATE
   *
   * Whether the amount increases, decreases, or stays the same, this
   * is now just a custodial balance adjustment in the DB — no on-chain
   * transaction — so the frontend just sends the new values.
   */

  const newAmount = payload.availableAmount;

  setUpdatingAd(true);

  onUpdateUsdtAd({
    adId: editingUsdtAd.adId,
    rate: payload.rate,
    minLimit: payload.minLimit,
    maxLimit: payload.maxLimit,
    newAmount,
  });
};

  /* -----------------------------------
     CANCEL AD (list view — works for both USWD & USDT)
  ----------------------------------- */
  const handleCancelOfferClick = (offer) => {
    if (!offer?.adId) return;
    setConfirmDeleteAdId(offer.adId);
    setCancelTargetAsset(offer.asset || "USWD");
  };

  const confirmCancelOffer = () => {
    if (!confirmDeleteAdId) return;

    const adId  = confirmDeleteAdId;
    const asset = cancelTargetAsset;

    setDeletingAdId(adId);
    setConfirmDeleteAdId(null);
    setCancelTargetAsset(null);

    if (asset === "USDT") {
      // USDT ads hold custodial funds tracked in the DB — the backend
      // credits the balance back internally, so this isn't a plain delete.
      onCancelUsdtAd?.({ adId });
    } else {
      socket.emit("p2p:delete-ad", { adId });
    }

    setTimeout(() => {
      setDeletingAdId((current) => (current === adId ? null : current));
    }, 5000);
  };


const handleEditOfferClick = (offer) => {
    if (!offer?.adId) return;

    const asset = offer.asset || "USWD";
    setSelectedAsset(asset);

    if (asset === "USDT") {
      setMyUsdtAd?.(offer);
    } else {
      setMyAds?.([offer]);
    }

    setRate(String(offer.rate ?? ""));
    setMinLimit(String(offer.minLimit ?? ""));
    setMaxLimit(String(offer.maxLimit ?? ""));
    setAvailableAmount(String(offer.availableAmount ?? ""));

    setMode("sell");
  };
  /* -----------------------------------
     SWITCH MODE (Buy / Sell)
  ----------------------------------- */
const handleSetMode = (nextMode) => {
  setMode(nextMode);

  // Manually clicking Sell (as opposed to clicking "Edit" on an
  // existing offer, which calls setMode directly) always starts a
  // fresh create form — clear any ad we were previously editing.
  // NOTE: this does NOT re-fetch from the server — myAds is kept
  // live by useP2PSocket in the background regardless of this tab
  // click, same as myUsdtAd is for USDT's own effect below.
 if (nextMode === "sell") {
    setRate("");
    setMinLimit("");
    setMaxLimit("");
    setAvailableAmount("");
}

  if (
    nextMode === "sell" &&
    !sellerCurrency
  ) {
    setSelectedCurrency(sellerCurrency || "GHS");
    setShowCurrencyPicker(true);
    return;
  }
};
  /* -----------------------------------
     SAVE CURRENCY
  ----------------------------------- */
  const saveCurrency = () => {
    if (!selectedCurrency) { toastError("Please select a currency"); return; }
    if (savingCurrency) return;
    setSavingCurrency(true);
    socket.emit("p2p:update-currency", { currency: selectedCurrency });
  };

  /* -----------------------------------
     SAVE PAYMENT DETAILS
  ----------------------------------- */
  const savePaymentDetails = () => {
    const entries = Object.entries(paymentDetails)
      .filter(([, v]) => v.trim())
      .map(([type, details]) => ({ type, details, instruction: paymentInstruction.trim() }));

    if (!entries.length) { toastError("Please add at least one payment detail"); return; }

    setShowPaymentDetails(false);
    socket.emit("p2p:set-payment-details", { chatId: myChatId, paymentDetails: entries });
  };

  /* -----------------------------------
     BUY FLOW
  ----------------------------------- */
const openBuyModal = async (offer) => {
  setSelectedOffer(offer);
  setBuyAmount("");
  setSelectedPaymentType(null);
  setShowBuyModal(true);
  await loadSellerPaymentDetails(offer.sellerChatId);
};

const handleBuySubmit = async (e) => {

  e.preventDefault();

  if (
    !selectedOffer ||
    creatingOrder
  ) return;

  const amount = Number(buyAmount);

  if (
    !amount ||
    amount < Number(selectedOffer.minLimit) ||
    amount > Number(selectedOffer.maxLimit)
  ) {
    toastError(
      `Amount must be between ${selectedOffer.minLimit} and ${selectedOffer.maxLimit}`
    );
    return;
  }

  setCreatingOrder(true);

  try {

   await loadSellerPaymentDetails(
  selectedOffer.sellerChatId
);

    onCreateOrder({
      adId:
        selectedOffer.adId ||
        selectedOffer._id,

      asset:
        selectedOffer.asset,

      amount,

      usdtAmount:
        amount,

      buyerChatId:
        myChatId,

      sellerChatId:
        selectedOffer.sellerChatId,
    });

    setTimeout(() => {
      setCreatingOrder((prev) => {
        if (prev) {
          toastError("Request timed out. Please try again.");
          setShowBuyModal(true);
          return false;
        }
        return prev;
      });
    }, 15000);

  } catch (err) {

    setCreatingOrder(false);

  }

};

/* -----------------------------------
   BUY FLOW — USDT (settlement-aware)
----------------------------------- */
const handleCreateUsdtOrder = async ({
  adId,
  sellerChatId,
  usdtAmount,
  settlementAsset,
}) => {

  if (!selectedOffer || creatingOrder) return;

  setCreatingOrder(true);

  try {

    await loadSellerPaymentDetails(sellerChatId);

    onCreateOrder({
      adId,
      asset: "USDT",
      amount: usdtAmount,
      usdtAmount,
      buyerChatId: myChatId,
      sellerChatId,
      settlementAsset,
    });

    setTimeout(() => {
      setCreatingOrder((prev) => {
        if (prev) {
          toastError("Request timed out. Please try again.");
          setShowBuyModal(true);
          return false;
        }
        return prev;
      });
    }, 15000);

  } catch (err) {

    setCreatingOrder(false);

  }

};
  /* -----------------------------------
     LOAD PAYMENT DETAILS ON PAYMENT PAGE
  ----------------------------------- */

  useEffect(() => {
  if (!showBuyModal) return;
  if (selectedPaymentType) return;

  if (
    Array.isArray(sellerPaymentDetails) &&
    sellerPaymentDetails.length > 0
  ) {

    setSelectedPaymentType(
      sellerPaymentDetails[0].type
    );
  }
}, [
  sellerPaymentDetails,
  showBuyModal,
  selectedPaymentType
]);

  /* -----------------------------------
     GO TO PAYMENT PAGE
  ----------------------------------- */
  const isOrderPayable =
    activeOrder &&
    typeof orderTimers?.[activeOrder.orderId] === "number" &&
    orderTimers[activeOrder.orderId] > 0;

  const goToPaymentPage = () => {
    if (!isOrderPayable) { toastInfo("⛔ Payment window has expired"); return; }
    setActiveP2PPage("payment");
  };
  

  /* -----------------------------------
     RATE SECTION (SELL FORM)
  ----------------------------------- */
  const renderRateSection = () => (
    <div className="space-y-1">
      <label className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
        Rate
        {sellerCurrency && (
          <span className="ml-1 text-xs font-normal text-neutral-400 dark:text-neutral-500">
            ({sellerCurrency}/USWD)
          </span>
        )}
      </label>

     <input
               className="
          w-full rounded-md border
          border-neutral-300
          dark:border-neutral-600
          px-3 py-2 text-base sm:text-sm
          bg-white dark:bg-neutral-800
          text-neutral-900 dark:text-neutral-100
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500/40
        "
        placeholder="Enter your selling rate"
        inputMode="decimal"
        value={rate}
        onChange={(e) => setRate(sanitizeDecimal2(e.target.value))}
      />
    </div>
  );

  const handleScroll = (e) => {
  const el = e.target;
  if (loadingMore || !hasMore) return;
  if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
    loadOffers(page + 1);
  }
};
  
/* -----------------------------------
     BUY LIST
  ----------------------------------- */
  const renderBuyList = () => {
    const filtered = (offers || []).filter((o) => {
    const matchesSearch =
  (o.displayName    || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
  (o.sellerUsername || "").toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCurrency = !marketCurrency || o.currency === marketCurrency;
      return matchesSearch && matchesCurrency;
    });

    if (!filtered.length) {
      return (
        <div className="py-10 text-center text-sm text-neutral-500 dark:text-neutral-400">
          No offers found
        </div>
      );
    }

    const methodColor = (type = "") => {
      const t = type.toLowerCase();
      if (t.includes("mtn"))                               return "#ffcc00";
      if (t.includes("vodafone") || t.includes("telecel")) return "#cc0000";
      if (t.includes("airteltigo"))                        return "#d00060";
      if (t.includes("bank"))                              return "#2563eb";
      if (t.includes("worldremit"))                        return "#6d28d9";
      if (t.includes("western"))                           return "#059669";
      if (t.includes("remitly"))                           return "#f97316";
      return "#6b7280";
    };

    return (
      <div
        className="max-h-[60vh] overflow-y-auto divide-y divide-neutral-100 dark:divide-neutral-800 pr-1
                   scrollbar-thin scrollbar-thumb-neutral-300 dark:scrollbar-thumb-neutral-600
                   scrollbar-track-transparent"
        onScroll={handleScroll}
      >
        {filtered.map((offer) => {
          const cur        = offer.currency || "";
          const asset      = offer.asset    || "USWD";
          const rate_n     = Number(offer.rate) || 0;
          const availAsset = Number(offer.availableAmount);
          const minFiat    = Number(offer.minLimit) * rate_n;
          const maxFiat    = Number(offer.maxLimit) * rate_n;
          const fmtFiat    = (n) => n.toLocaleString(undefined, { maximumFractionDigits: 2 });
          const fmtAsset   = (n) => n.toLocaleString(undefined, { maximumFractionDigits: 6 });

        return (
  <div key={offer.adId} className="flex items-start justify-between gap-3 py-4">
    <div className="min-w-0 flex-1 space-y-1.5">
      <div className="flex items-center gap-2">
        {/* Avatar with online dot */}
        <div className="relative shrink-0 h-7 w-7">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-neutral-300 dark:bg-neutral-700 text-lg overflow-hidden">
            {offer.sellerProfileImageUrl ? (
             <img
  src={offer.sellerProfileImageUrl}
  alt={offer.displayName || offer.sellerDisplayName || offer.sellerUsername || ""}
  className="w-full h-full rounded-full object-cover"
/>
            ) : "👤"}
          </div>
          {(() => {
            const liveUser = users.find(
              (u) => String(u.chatId) === String(offer.sellerChatId)
            );
            const isOnline = liveUser?.online ?? false;
            return (
              <span
                className={`absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-white dark:border-neutral-900 ${
                  isOnline ? "bg-green-500" : "bg-neutral-400"
                }`}
              />
            );
          })()}
        </div>
       <span className="truncate text-sm font-semibold text-neutral-900 dark:text-neutral-100">
  {offer.displayName || offer.sellerDisplayName || offer.sellerUsername}
</span>
      </div>
                {(offer.tradeCount != null || offer.thumbsUpPct != null) && (
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-neutral-500 dark:text-neutral-400">
                    {offer.tradeCount != null && (
                      <span>Trade: {offer.tradeCount} Trades{offer.completionRate != null ? ` (${offer.completionRate}%)` : ""}</span>
                    )}
                    {offer.thumbsUpPct != null && (
                      <>
                        <span className="text-neutral-300 dark:text-neutral-600">|</span>
                        <span className="flex items-center gap-0.5">
                          <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                          </svg>
                          {offer.thumbsUpPct}%
                        </span>
                      </>
                    )}
                  </div>
                )}

                <div className="flex items-baseline gap-0.5 leading-none">
                  {cur && <span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">{cur}&nbsp;</span>}
                  <span className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">{offer.rate}</span>
                  <span className="ml-0.5 text-xs text-neutral-500 dark:text-neutral-400">/{asset}</span>
                </div>

                <div className="text-xs text-neutral-500 dark:text-neutral-400">
                  Limit <span className="font-medium text-neutral-700 dark:text-neutral-300">{fmtFiat(minFiat)} – {fmtFiat(maxFiat)}{cur ? ` ${cur}` : ""}</span>
                </div>
                <div className="text-xs text-neutral-500 dark:text-neutral-400">
                  Available <span className="font-medium text-neutral-700 dark:text-neutral-300">{fmtAsset(availAsset)} {asset}</span>
                </div>
              </div>

              <div className="flex shrink-0 flex-col items-end gap-2 pt-0.5">
                {Array.isArray(offer.paymentTypes) && offer.paymentTypes.length > 0 && (
                  <div className="flex flex-col items-end gap-1">
                    {offer.paymentTypes.slice(0, 3).map((type) => (
                      <div key={type} className="flex items-center gap-1.5">
                        <span className="max-w-[120px] truncate text-right text-xs text-neutral-600 dark:text-neutral-400">
                          {type.length > 15 ? type.slice(0, 14) + "…" : type}
                        </span>
                        <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: methodColor(type) }} />
                      </div>
                    ))}
                    {offer.paymentTypes.length > 3 && (
                      <span className="text-xs text-neutral-400 dark:text-neutral-500">+{offer.paymentTypes.length - 3} more</span>
                    )}
                  </div>
                )}
                {asset !== "USDT" && (
                  <div className="flex items-center gap-1 text-xs text-neutral-400 dark:text-neutral-500">
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="9" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 7v5l3 3" />
                    </svg>
                    {typeof offer.paymentWindow === "number" ? `${offer.paymentWindow} min` : "15 min"}
                  </div>
                )}
{String(offer.sellerChatId) === String(myChatId) ? (
  <div className="mt-1 flex flex-col items-stretch gap-1.5">
    <button
      onClick={() => handleCancelOfferClick(offer)}
      disabled={deletingAdId === offer.adId}
      className="rounded-md bg-red-500 px-5 py-1.5 text-sm font-semibold text-white hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
    >
      {deletingAdId === offer.adId ? "Cancelling..." : "Cancel"}
    </button>
    <button
      onClick={() => handleEditOfferClick(offer)}
      disabled={deletingAdId === offer.adId}
      className="rounded-md border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 px-5 py-1.5 text-sm font-semibold text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
    >
      Edit
    </button>
  </div>
) : (
  <button
    onClick={() => openBuyModal(offer)}
    className="mt-1 rounded-md bg-green-500 px-5 py-1.5 text-sm font-semibold text-white hover:bg-green-600 active:scale-95 transition-all"
  >
    Buy
  </button>
)}
              </div>
            </div>
          );
        })}

        {loadingMore && (
          <div className="py-4 text-center text-xs text-neutral-400 dark:text-neutral-500">
            Loading more…
          </div>
        )}
        {!hasMore && filtered.length > 0 && (
          <div className="py-4 text-center text-xs text-neutral-400 dark:text-neutral-500">
            All offers loaded
          </div>
        )}

      </div>
    );
  };
  /* -----------------------------------
     CURRENCY PICKER PAGE
  ----------------------------------- */
  const renderCurrencyPicker = () => (
    <div className="flex h-full w-full flex-col bg-white dark:bg-neutral-800">
      <div className="flex items-center gap-3 border-b border-neutral-200 dark:border-neutral-700 px-4 py-4">
        <button
          onClick={() => {
            setShowCurrencyPicker(false);
            if (!sellerCurrency) setMode("buy");
          }}
          className="flex items-center justify-center rounded-md p-1.5 text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-700 hover:text-neutral-800 dark:hover:text-neutral-200 transition"
          aria-label="Back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div>
          <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100">Select Currency</h2>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">Choose the currency buyers will pay you in when you sell USWD.</p>
        </div>
      </div>
      <div className="flex-1 px-4 py-4">
        <select
          value={selectedCurrency}
          onChange={(e) => setSelectedCurrency(e.target.value)}
          className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-900 border-neutral-300 dark:border-neutral-600 text-neutral-900 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-blue-500/40 transition"
        >
          {CURRENCIES.map((c) => <option key={c.code} value={c.code}>{c.code}</option>)}
        </select>
      </div>
      <div className="border-t border-neutral-200 dark:border-neutral-700 p-4">
        <button
          onClick={saveCurrency}
          disabled={savingCurrency}
          className="w-full rounded-md bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500/40 disabled:cursor-not-allowed disabled:opacity-50 transition"
        >
          {savingCurrency ? "Saving…" : "Continue"}
        </button>
      </div>
    </div>
  );

  /* -----------------------------------
     PAYMENT DETAILS PAGE
  ----------------------------------- */
  const renderPaymentDetailsPage = () => (
    <div className="flex h-full w-full flex-col bg-white dark:bg-neutral-800">
      <div className="flex items-center gap-3 border-b border-neutral-200 dark:border-neutral-700 px-4 py-3">
        <button
          onClick={() => setShowPaymentDetails(false)}
          className="flex items-center justify-center rounded-md p-1.5 text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-700 hover:text-neutral-800 dark:hover:text-neutral-200 transition"
          aria-label="Back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div>
          <h2 className="text-base font-semibold text-neutral-900 dark:text-neutral-100">Payment Details</h2>
          <p className="text-xs text-neutral-500 dark:text-neutral-400">Add at least one method buyers can use to pay you</p>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
        {PAYMENT_TYPES.map((type) => (
          <div key={type} className="space-y-1">
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300">{type}</label>
            <input
              className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-900 border-neutral-300 dark:border-neutral-600 text-neutral-900 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40 transition"
              placeholder={`Enter your ${type} details`}
              value={paymentDetails[type] || ""}
              onChange={(e) => setPaymentDetails((prev) => ({ ...prev, [type]: e.target.value }))}
            />
          </div>
        ))}
        <div className="space-y-1">
          <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300">
            Payment Instruction <span className="ml-1 text-xs font-normal text-neutral-400 dark:text-neutral-500">(optional)</span>
          </label>
          <textarea
            rows={4}
            className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-900 border-neutral-300 dark:border-neutral-600 text-neutral-900 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40 resize-none transition"
            placeholder="Any special instructions for buyers"
            value={paymentInstruction}
            onChange={(e) => setPaymentInstruction(e.target.value)}
          />
        </div>
        <div className="h-4" />
      </div>
      <div className="border-t border-neutral-200 dark:border-neutral-700 px-4 py-3 flex gap-3">
        <button
          onClick={() => setShowPaymentDetails(false)}
          className="flex-1 rounded-md border px-4 py-2.5 text-sm font-medium border-neutral-300 dark:border-neutral-600 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
        >
          Cancel
        </button>
        <button
          onClick={savePaymentDetails}
          className="flex-1 rounded-md bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500/40 transition"
        >
          Save &amp; Continue
        </button>
      </div>
    </div>
  );

  const renderAdDoneScreen = () => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-6 bg-white dark:bg-neutral-800 p-6 text-center">
    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
      <svg className="h-10 w-10 text-green-600 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <div>
      <p className="text-xl font-bold text-neutral-900 dark:text-white">
        Advertisement {adDoneInfo?.action === "updated" ? "Updated" : "Created"}!
      </p>
      <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
        Your {adDoneInfo?.asset} advertisement has been {adDoneInfo?.action} successfully.
      </p>
    </div>
   <button
    onClick={() => {
    setShowAdDone(false);
    setAdDoneInfo(null);
    setMode("buy");
}}
      className="w-full max-w-xs rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-700"
    >
      Done
    </button>
  </div>
);

  /* -----------------------------------
     RENDER
  ----------------------------------- */
  return (
    <div className="flex h-full w-full flex-col bg-white text-neutral-900 dark:bg-neutral-800 dark:text-neutral-200">

      {showCurrencyPicker && renderCurrencyPicker()}

      {!showCurrencyPicker && showPaymentDetails && renderPaymentDetailsPage()}

      {!showCurrencyPicker && !showPaymentDetails && showAdDone && renderAdDoneScreen()}

      {!showCurrencyPicker && !showPaymentDetails && !showAdDone && (
        <>
                  <BuyOrder
            open={showBuyModal}
            offer={selectedOffer}
            buyAmount={buyAmount}
            setBuyAmount={setBuyAmount}
            creatingOrder={creatingOrder}
            paymentDetails={sellerPaymentDetails}
            sellerCurrency={sellerCurrency}
            selectedPaymentType={selectedPaymentType}
            setSelectedPaymentType={setSelectedPaymentType}
            onClose={() => setShowBuyModal(false)}
            onSubmit={handleBuySubmit}
            onCreateUsdtOrder={handleCreateUsdtOrder}
          />

         {/* PAYMENT PAGE */}
{activeP2PPage === "payment" && activeOrder && (
  <OrderPayment
    socket={socket}
    order={activeOrder}
    wallet={wallet}
    remainingTime={orderTimers[activeOrder.orderId]}
    paymentDetails={sellerPaymentDetails}
    sellerCurrency={sellerCurrency}
     sendMessage={sendMessage} 
      setUsers={setUsers}
     setPendingMedia={setPendingMedia}
    onOpenChat={() =>
      onOpenDm(
        activeOrder.sellerChatId,
        activeOrder.sellerUsername
      )
    }
       onBackToMarket={() => {
      setActiveP2PPage("market");
    }}
    myChatId={myChatId}
    setMessages={setMessages}
       showToast={showToast}
    getUserKey={getUserKey}
    uuid={uuid}
  />
)}

          {/* ORDERS PAGE */}
          {activeP2PPage === "orders" && (
            <Orders
  orders={p2pOrders}
  orderTimers={orderTimers}
  myChatId={myChatId}
  onBack={() => setActiveP2PPage("market")}
  onConfirmPayment={onConfirmPayment}
/>
          )}

          {/* MARKET PAGE */}
        {activeP2PPage === "market" && !showBuyModal && (
  <>
 <div className="mb-3 flex items-center gap-3 px-4 pt-4">
  {mobileView && (
    <>
      <span className="text-base font-semibold">P2P Marketplace</span>
      <div className="flex-1" />

      <select
        value={marketCurrency}
        onChange={(e) => setMarketCurrency(e.target.value)}
        className="rounded-md border px-2 py-1 text-sm ..."
      >
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>{c.code}</option>
        ))}
      </select>
    </>
  )}
</div>

              <div className="rounded-lg bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700 shadow-sm">

                <div className="border-b border-neutral-200 dark:border-neutral-700 px-4 pt-4 pb-0">

                  <div className="flex items-center gap-3 pb-3">
                    <div className="flex overflow-hidden rounded-md border border-neutral-300 dark:border-neutral-600">
                      {["buy", "sell"].map((v) => (
                        <button
                          key={v}
                          onClick={() => handleSetMode(v)}
                          className={`px-5 py-2 text-sm font-semibold transition ${
                            mode === v
                              ? v === "buy" ? "bg-yellow-400 text-neutral-900" : "bg-red-500 text-white"
                              : "bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300"
                          }`}
                        >
                          {v === "buy" ? "Buy" : "Sell"}
                        </button>
                      ))}
                    </div>

                    <div className="flex-1" />

                    {!mobileView && (
                      <select
                        value={marketCurrency}
                        onChange={(e) => setMarketCurrency(e.target.value)}
                        className="rounded-md border px-2 py-1.5 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 text-neutral-900 dark:text-neutral-100 focus:outline-none"
                      >
                        {CURRENCIES.map((c) => <option key={c.code} value={c.code}>{c.code}</option>)}
                      </select>
                    )}

                    <button
                      onClick={() => setActiveP2PPage("orders")}
                      className="rounded-md border px-4 py-1.5 text-sm border-neutral-300 dark:border-neutral-600 hover:bg-neutral-100 dark:hover:bg-neutral-800 transition"
                    >
                      📦 Orders
                    </button>

                    {mode === "buy" && isOrderPayable && (
                      <button
                        onClick={goToPaymentPage}
                        className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-700 transition"
                      >
                        💳 Go to Payment
                      </button>
                    )}
                  </div>

                  <div className="flex items-center gap-3 pb-3">
                    <div className="flex items-center gap-2">
                      <label className="text-sm text-neutral-500 dark:text-neutral-400">Asset</label>
                      <select
                        value={selectedAsset}
                        onChange={(e) => setSelectedAsset(e.target.value)}
                        className="rounded-md border px-2 py-1.5 text-sm font-medium bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none"
                      >
                        {ASSETS.map((a) => <option key={a}>{a}</option>)}
                      </select>
                    </div>
                    {mode === "buy" && (
                      <input
                        className="flex-1 rounded-md border px-3 py-1.5 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none focus:ring focus:ring-blue-500/30"
                        placeholder="Search by username…"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    )}
                  </div>
                </div>

                <div className="px-4 py-2">
                  {mode === "buy" ? (
                    renderBuyList()
                  ) : (
                  <form onSubmit={handleCreateAd} className="space-y-3 py-3">
                    {(selectedAsset === "USDT"
    ? editingUsdtAd
    : editingUswdAd) && (
    <div className="flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700 dark:border-blue-900/50 dark:bg-blue-900/20 dark:text-blue-300">
        <svg
            className="h-4 w-4 shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
        </svg>

        <span>
            You're updating your existing {selectedAsset} advertisement.
        </span>
    </div>
)}
                      {selectedAsset === "USWD" ? renderRateSection() : (
                        <input
                          className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none focus:ring focus:ring-blue-500/30"
                          placeholder="Rate"
                          inputMode="decimal"
                          value={rate}
                          onChange={(e) => setRate(sanitizeDecimal2(e.target.value))}
                        />
                      )}
                      <input
                        className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none focus:ring focus:ring-blue-500/30"
                        placeholder="Min Limit"
                        inputMode="decimal"
                        value={minLimit}
                        onChange={(e) => setMinLimit(sanitizeDecimal2(e.target.value))}
                      />
                      <input
                        className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none focus:ring focus:ring-blue-500/30"
                        placeholder="Max Limit"
                        inputMode="decimal"
                        value={maxLimit}
                        onChange={(e) => {
                          const v = sanitizeDecimal2(e.target.value);
                          setMaxLimit(v);
                          setAvailableAmount(v);
                        }}
                      />
                      <input
                        className="w-full rounded-md border px-3 py-2 text-sm bg-white dark:bg-neutral-800 border-neutral-300 dark:border-neutral-600 focus:outline-none focus:ring focus:ring-blue-500/30"
                        placeholder="Available Amount"
                        inputMode="decimal"
                        value={availableAmount}
                        onChange={(e) => setAvailableAmount(sanitizeDecimal2(e.target.value))}
                      />
                    <button
                        type="submit"
                      disabled={creatingAd || updatingAd}
                        className="w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50 transition"
                      >
                       
{
  creatingAd
    ? "Creating..."
    : updatingAd
    ? "Updating..."
    : (selectedAsset === "USDT" ? editingUsdtAd : editingUswdAd)
    ? "Update Advertisement"
    : "Create Advertisement"
}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}

    {/* CANCEL AD CONFIRMATION MODAL */}
      {confirmDeleteAdId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-sm rounded-xl bg-white dark:bg-neutral-800 shadow-xl p-6 space-y-4">
            <div className="space-y-1">
              <h3 className="text-base font-semibold text-neutral-900 dark:text-neutral-100">
                Cancel Advertisement
              </h3>
              <p className="text-sm text-neutral-500 dark:text-neutral-400">
                {cancelTargetAsset === "USDT"
                  ? `This will close your USDT advertisement and credit the remaining ${
                      offers.find(
                        (o) => String(o.adId) === String(confirmDeleteAdId)
                      )?.availableAmount ?? ""
                    } USDT back to your balance. This action cannot be undone.`
                  : "This will cancel your advertisement. This action cannot be undone."}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setConfirmDeleteAdId(null);
                  setCancelTargetAsset(null);
                }}
                className="flex-1 rounded-md border border-neutral-300 dark:border-neutral-600 px-4 py-2.5 text-sm font-medium text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
              >
                Keep Ad
              </button>
              <button
                onClick={confirmCancelOffer}
                className="flex-1 rounded-md bg-red-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-600 transition"
              >
                Cancel Ad
              </button>
            </div>
          </div>
        </div>
      )}
      
    </div>
  );
}